export default{
    workOrder: '工单管理',
}


// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/workOrder.js